import React, { ReactNode, useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { AddButton } from 'components/atoms/button';
import { NewConversationModal } from '../new-conversation-modal';

const Wrapper = styled.div`
  padding: var(--spacing-06);
  padding-bottom: var(--spacing-02);
`;

type TriggerComponentType = ({ onClick }) => ReactNode;

export const NewConversationAction = ({
  onSuccess,
  trigger,
}: {
  onSuccess: () => void;
  trigger?: TriggerComponentType;
}): JSX.Element => {
  const [isVisible, setNewConversationModalVisibility] = useState(false);
  const openModal = useCallback(
    () => setNewConversationModalVisibility(true),
    [],
  );

  return (
    <>
      <NewConversationModal
        onSuccess={() => {
          setNewConversationModalVisibility(false);
          onSuccess();
        }}
        isVisible={isVisible}
        onCancel={() => setNewConversationModalVisibility(false)}
      />
      {trigger != null ? (
        trigger({ onClick: openModal })
      ) : (
        <Wrapper>
          <AddButton
            size="small"
            type="default"
            iconPlacement="right"
            data-test-id="projects.conversations.add_new_conversation"
            onClick={openModal}
          >
            <FormattedMessage id="projects.conversations.new_shared" />
          </AddButton>
        </Wrapper>
      )}
    </>
  );
};
